<template>
  <div style="height: 100%; position: relative">
    <div class="m-top">
      <select v-model="param.materialType" @change="getSourceList()">
        <option
          :label="item.label"
          :value="item.materialType"
          v-for="(item, i) in categroy"
          :key="i + 'shaixuan'"
        ></option>
      </select>
      <div style="" class="search">
        <input
          @keyup.enter="getSourceList"
          v-model="param.searchText"
          type="text"
          placeholder="输入关键词搜索"
          style=""
        />
        <i @click="getSourceList()" class="iconfont icon-sousuoxiao"></i>
      </div>
    </div>
    <div class="m-list">
      <ul class="m-ul" style="">
        <li class="m-column" @click="addUp()">+</li>
        <li
          v-for="(source, index) in sourceList"
          :key="index"
          :style="transfromImg(source)"
          @click="addPendant(source)"
        >
          <div class="m-houzui">
            <span>{{ dongtai(source) }}</span>
          </div>
          <div class="m-name">
            <span>{{ source.materialName }}</span>
          </div>
          <div class="m-edit">
            <div @click.stop="editSource(source)"><span>编辑</span></div>
            <div @click.stop="delSource(source.materialId)">
              <span>删除</span>
            </div>
          </div>
        </li>
      </ul>
      <center v-if="sourceList.length <= 0 && !loading">
        <img src="@/assets/images/null.png" />
      </center>
      <div class="selector_box" v-show="showPanel">
        <div class="selector_box_content">
          <div class="tab_action tab_bg">
            <div class="tab">
              <div
                class="tab_action addform_box tab_pendant tab_bg"
                style="height: calc(100% - 43px)"
              >
                <div v-show="showPanel" class="add-box addform_box">
                  <div class="add-content">
                    <div class="setup_cancel" @click="showPanel = false">
                      返回
                    </div>

                    <div class="setup_title"><i></i>素材上传</div>
                    <div class="setup_content">
                      <div class="setup_box">
                        <div class="setup_lable">素材名称：</div>
                        <div class="setup_block">
                          <input
                            type="text"
                            v-model="addForm.materialName"
                            value=""
                            placeholder="请输入素材名称"
                          />
                        </div>
                      </div>
                      <div class="setup_box">
                        <div class="setup_lable">素材类型：</div>
                        <div class="setup_block">
                          <select
                            style="padding: unset"
                            v-model="addForm.materialType"
                          >
                            <option
                              :label="item.label"
                              :value="item.materialType"
                              v-for="(item, i) in categroy"
                              :key="i"
                            ></option>
                          </select>
                        </div>
                      </div>
                      <div class="setup_box fengmian">
                        <div class="setup_lable">素材图片：</div>
                        <div class="setup_block" style="position: relative">
                          <div
                            class="uploader"
                            v-if="
                              addForm.materialPath == null ||
                              addForm.materialPath.length <= 0
                            "
                          >
                            +
                          </div>
                          <div
                            v-if="
                              addForm.materialPath != null &&
                              addForm.materialPath.length > 0
                            "
                            class="uploader_img"
                          >
                            <img
                              v-if="isImg(addForm.materialPath)"
                              :src="addForm.materialPath"
                              alt=""
                            />
                            <img
                              v-else-if="addForm.materialJson"
                              :src="addForm.materialJson.materialCover"
                              alt=""
                            />
                            <img v-else :src="defaultImg" alt="" />
                          </div>
                          <div class="defaultupload">
                            <fileUpload
                              id="imgupload"
                              accept="jpg,png/*"
                              typefolder="stageImg"
                              parentfolder="material"
                              @progress="uploadProgress"
                              @checkfile="checkfile"
                              @error="uploadError"
                              @success="uploadSuccess"
                            ></fileUpload>
                          </div>
                        </div>
                      </div>
                      <div class="setup_box">
                        <div v-if="uppro > 0 && uppro < 100">
                          上传中 {{ uppro }}%
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="savebtn">
                    <span @click="saveMaterial" class="confirmbtn"
                      >保存素材</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div @click="showPanel = false" class="selector_box_close">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
      </div>

      <pagination
        v-if="sourceList.length > 0"
        class="pull-right"
        :paginationOpt="Pagination"
        @switchPage="employeePagesFn"
        style="bottom: 0; width: 96%; position: absolute; box-shadow: none"
      />
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination/index.vue'
import { javaimg } from '@/components/util/util.js'
import fileUpload from '@/components/ali_oss/alioss.vue'
import { t9oss } from '@/components/util/util.js'
import { repUrl, getVideo } from '@/components/util/util_fun.js'
export default {
  data () {
    return {
      uppro: 0,// 文件上传进度
      upproCover: 0,// 封面上传进度
      showPanel: false,
      sourceList: [],
      param: {
        "searchText": "",
        "pageIndex": 0,
        "pageSize": 39,
        "sort": 1,//	排序 1.正序 2.倒序
        "materialType": 2,//素材类型 0.默认不筛选 1.挂件 2.场景
        "materialSource": 1,//素材来源 0.默认不筛选 1.个人上传 2.平台素材	
      },
      // 素材添加参数
      addForm: {
        "materialName": '',
        "materialPath": '',
        "materialType": '2',// 2-1=2D 2-2=3D 2-3=vr场景
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '',
      },
      Pagination: {
        //分页
        pageIndex: 1,
        pageSize: 39,
        totalCount: 1,
        pageCount: 0
      },
      categroy: [{
        "label": "全部分类",
        "materialType": "2",
        "children": []
      }]
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
  },
  components: {
    pagination,
    fileUpload
  },
  created () {
    this.getSourceList()
    this.get('/vup/static/config/material.json').then((res) => {
      var guajian = res.data[1].children
      for (let a = 0; a < guajian.length; a++) {
        this.categroy.push(guajian[a])
      }
    })
  },
  methods: {

    // 获取素材列表
    getSourceList (cb) {

      this.$emit('update:loading', true)

      this.post("/material/findMaterialList", this.param).then((res) => {

        if (res.status == "200") {
          this.sourceList = res.data[0]

          this.Pagination.totalCount = res.data[1]
          this.Pagination.pageCount = Math.ceil(this.Pagination.totalCount / this.Pagination.pageSize)

          this.sourceList.forEach(t => {

            if (t.materialPath.indexOf('http') == -1) {
              t.materialPath = javaimg + t.materialPath
              // 背景图中不能含空格
              // t.materialPath = t.materialPath.replace(/\s/g, encodeURIComponent(' '))
            }

          })
          this.getWidth()
          this.$emit('update:loading', false)
        } else {
          this.$message.error('列表获取失败', res.message)
          this.$emit('update:loading', false)
        }

      })
        .catch((fail) => {
          this.$message.error('列表获取失败', fail)
          console.error(fail)
          this.$emit('update:loading', false)
        })
      !!cb && cb()//分页用到了
    },
    //点击加号上传挂件
    addUp () {
      this.showPanel = true
      this.addForm = {
        "materialName": '',
        "materialPath": '',
        "materialType": '2',// 2-1=2D 2-2=3D 2-3=vr场景
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '', // 放置 封面图片
      },
        console.log('上传show')
    },
    dongtai (back) {
      let name = back.materialPath.toLowerCase().substring(back.materialPath.lastIndexOf('.') + 1)
      if (name == "mov" || name == "ogg" || name == "mp4" || name == "gif") {
        return "动态"
      }
      else {
        return ""
      }

    },
    // 素材列表的点击事件
    addPendant (source) {
      //   source.rolesId = this.selfUser.rolesId

    },
    transfromImg (item) {
      // console.log('转换的imng', item)
      if (this.isImg(item.materialPath)) {
        return {
          backgroundImage: `url('${item.materialPath}?x-oss-process=style/fmslt')`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat'
        }
      } else if (item.materialJson) {
        if (typeof item.materialJson == 'string') {
          item.materialJson = JSON.parse(item.materialJson)
        }
        return {
          backgroundImage: `url('${item.materialJson.materialCover}?x-oss-process=style/fmslt')`,
          backgroundSize: 'cover',
        }
      }

    },
    // 编辑素材
    editSource (source) {
      if (typeof source.materialJson == 'string') {
        source.materialJson = JSON.parse(source.materialJson)
      }
      this.addForm = source
      this.showPanel = true
    },
    // 保存素材
    saveMaterial () {
      if (this.addForm.materialPath == '') return this.$message.error("文件不能为空")
      if (this.uppro != 100 || this.upproCover != 100) {
        // this.$message.warning("请等待文件上传完成")
      }
      if (typeof this.addForm.materialJson != 'string') {
        this.addForm.materialJson = JSON.stringify(this.addForm.materialJson)
      }
      this.saveloading = true
      // 修改
      if (this.addForm.materialType == 0) {
        this.addForm.materialType = 1
      }
      if (this.addForm.materialId) {
        this.post("/material/editMaterial", this.addForm).then((res) => {
          this.saveloading = false
          if (res.status == "200") {
            this.$message.success('修改成功')

          } else if (res.status == "21") {

            this.$message.error(res.message)
          } else {

            this.$message.error('修改失败')
          }
          this.successGetList()


        })
          .catch((fail) => {
            this.saveloading = false
          })
      } else {
        // 新增
        this.post("/material/saveMaterial", this.addForm).then((res) => {
          this.saveloading = false
          if (res.status == "200") {


            this.sourceList.push(res.data)
            this.$message.success("添加成功")

          } else {
            this.$message.error("添加失败")
          }
          this.successGetList()

        })
          .catch((fail) => {
            this.saveloading = false
          })
      }

    },
    // 素材新增编辑成功后的回调
    successGetList () {
      this.showPanel = false
      this.addForm = {
        "materialName": '',
        "materialPath": '',
        "materialType": '0',//1.挂件 2.场景
        "materialSource": 1,//1.个人上传 2.平台素材
        "materialSize": 0,
        "materialJson": '', // 放置 封面图片
      }
      this.getSourceList()
    },
    //上传成功！
    async uploadSuccess (json) {

      if (json.fileDir.length <= 0) {
        this.$message.error("上传文件不可用!")
      } else {


        this.addForm.materialPath = t9oss + '/' + repUrl(json.fileUrl)
        // this.addForm.materialPath = (json.fileUrl).split('?')[0]
        this.addForm.materialSize = json.size
        // console.log(this.addForm);

        // 判断是否为对象,如果是字符串,则转换为对象

        if (typeof this.addForm.materialJson == 'string' && this.addForm.materialJson != '') {
          this.addForm.materialJson = JSON.parse(this.addForm.materialJson)
        } else {
          this.addForm.materialJson = {}
        }
        if (json.fileType == 'mp4' || json.fileType == 'mov') {
          try {
            const url = await getVideo(this.addForm, 'stageBgc/material/')
            this.$set(this.addForm.materialJson, 'materialCover', url)
            this.$message.success("上传成功")
          } catch (error) {
            this.addForm.materialJson.materialCover = ''
            this.$message.error("上传文件封面获取失败")
          }
        } else if (json.fileType == 'png' || json.fileType == 'jpg' || json.fileType == 'jpeg' || json.fileType == 'gif') {
          this.addForm.materialJson.materialCover = this.addForm.materialPath
          this.$message.success("上传成功")
        } else {
          this.$message.error("上传文件不可用!")
        }

      }

    },

    //上传失败
    uploadError (err) {
      this.uploadloading = false
      this.$message.error("上传失败！")
      console.log(err)
    },

    //文件选择成功
    checkfile (file) {
      this.uploadloading = true

    },
    //进度条
    uploadProgress (progress) {
      this.uppro = parseInt(progress * 100)
    },
    // 删除素材
    delSource (code) {
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '此操作将永久删除该素材, 是否继续?'
      }).then(() => {
        this.post("/material/deleteMaterial", { code: code }).then((res) => {
          if (res.status == "200") {
            this.sourceList.find((t, index) => {
              if (t.materialId == code) {
                this.sourceList.splice(index, 1)
              }
            })
            this.$message.success("删除成功")
          } else {
            this.$message.error("删除失败")
          }
        })
          .catch((fail) => {
          })
      })
    },
    // 判断是否为图片
    isImg (url) {
      return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(url)
    },
    // 获取图片宽高
    async getWidth () {
      for (let i = 0; i < this.sourceList.length; i++) {
        let img = new Image()
        img.src = this.sourceList[i].materialPath
        var promise = new Promise((reslove) => {
          img.onload = async function () {

            reslove()
          }
        })
        await promise
        if (img.width > 320) {
          this.sourceList[i].width = 320
          this.sourceList[i].height = 320
        } else if (img && img.width) {
          this.sourceList[i].width = img.width
          this.sourceList[i].height = img.height
        }
        // if (this.isH5) {
        //   this.sourceList[i].width = this.sourceList[i].width / 5
        //   this.sourceList[i].height = this.sourceList[i].height / 5

        // }
      }
    },
    // 分页
    employeePagesFn (pageIndex, cb) { //pageIndex --- 分页组件返回的页码，    cb ---- 主要目的是为分页加锁，固定参数
      let self = this

      self.Pagination.pageIndex = pageIndex
      self.param.pageIndex = pageIndex - 1

      self.getSourceList(cb)
    },
  },
}
</script>

<style lang="scss" scoped>
.m-top{
        height: 5%;
        display: flex;
        padding-right: 4%;
}
.m-list{
    height: 95%;
    position: relative;
    .m-ul{
    // padding-top: 20px;
    // height: calc(80% - 10px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    border-radius: 10px;
    // margin: 0 -0.27778rem;
    
    li{
    background: #f6f6fb;
    width: 8.33%;
    margin:10px;
    margin-bottom: 40px;
    height: 120px;
    border-radius: 1.11111rem;
    cursor: pointer;
    position: relative;
    color: #585858;
     &:hover {
       .m-edit{
         display: flex;
          bottom: 0;
          opacity: 1;
       }
       
  }
    }
    .m-column{
         text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 58px;
    // background: #ffe5d9;
    color: #af8a79;
    }
    .m-houzui{
        background-color: #f95f8e;
        color: #fff;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 0 20px 0 20px;
        padding: 0 12px;
        font-size: 12px;
        line-height: 20px;
    }
    .m-name{
          position: absolute;
    bottom: -24px;
    text-align: center;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    }
    .m-edit{
       border-radius: 0 0 20px 20px;
       height: 30px;
        position: absolute;
        transition: all .3s ease 0s;
        bottom: -1.94444rem;
        left: 0;
        width: 100%;
        color: #fff;
        overflow: hidden;
        background: #f4acb7;
        opacity: 0;
            font-size: .77778rem;
        display: flex;
        div{
          align-items: center;
          height: 100%;
          width: 50%;
          justify-content: center;
           font-size: .77778rem;
          display: flex;
          &:hover{
            background: #fcc9d1;
            color: #fff;
          }
        }
    }
    }
}
</style>